import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { ADMIN_MANAGE_GRADES } from '@/shared/config/adminGrade';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const System = lazy(() => import('@/pages/system'));
const AdminList = lazy(() => import('@/pages/system/admin/AdminList'));
const AdminDetail = lazy(() => import('@/pages/system/admin/AdminDetail'));
const LogList = lazy(() => import('@/pages/system/log/LogList'));

export const systemRoutes: TypedRouteObject = {
	path: ROOTS.SYSTEM,
	element: withSuspense(System),
	handle: {
		title: '설정',
		subTitle: '락앤런 관리자 운영 기능 설정',
		permission: 'SETTINGS', // 설정 관리 권한 필요
		grades: ADMIN_MANAGE_GRADES // MASTER, AAA 등급만 접근 가능
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 관리자 목록
		{
			path: paths.system.admin.list.path,
			element: withSuspense(AdminList),
			handle: {
				title: '사용자 계정 관리',
				subTitle: '락앤런 관리자 계정 생성 및 관리'
			}
		},
		{
			path: paths.system.admin.detail.path,
			element: withSuspense(AdminDetail),
			handle: {
				isGoBack: true,
				title: '사용자 계정 상세정보',
				subTitle: '설정 > 사용자계정 > 상세정보'
			}
		},
		// 로그
		{
			path: paths.system.log.list.path,
			element: withSuspense(LogList),
			handle: {
				isGoBack: true,
				title: '시스템 로그',
				subTitle: '락앤런 관리자 시스템 로그'
			}
		}
	]
};
